import request from 'umi-request';
import type { LoginRequest } from '../model/loginRequest';
import type { ApiResponse } from '../model/apiResponse';
import type { RegistrationRequest } from '../model/registrationRequest';
import { environment } from './../../environment/environment';
import type { ForgotPasswordRequest } from '../model/forgetPasswordRequest';
import type { ResetPasswordRequest } from '../model/resetPasswordRequest';

export async function login(loginRequest: LoginRequest): Promise<ApiResponse> {
  return request('/users/login/app', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(loginRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function registerDetails(registrationRequest: RegistrationRequest): Promise<ApiResponse> {
  return request('/registrationpersonaldetails', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(registrationRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function forgetPassword(forgotPasswordRequest: ForgotPasswordRequest): Promise<ApiResponse> {
  return request('/password/forgot-password', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(forgotPasswordRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function resetPassword(resetPasswordRequest: ResetPasswordRequest): Promise<ApiResponse> {
  return request('/password/reset-password', {
    method: 'POST',
    prefix: environment.baseUrl,
    body: JSON.stringify(resetPasswordRequest),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
    }
  })
    .then(function (reponse: ApiResponse) {
      return reponse
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}